













































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import {
  NumberInput,
} from "../../../../../../base/components/system";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { DateDurationPicker, OptionDropDownSelector } from "../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { DocumentKind } from "../../../../../../documaker/domain/format";
import { DocumentKindDropDownSelector } from "../../../../../../documaker/components/format/selectors";
import { IConfiguration } from "../../../../../domain/configuration";

@Component({
  components: {
    NumberInput,
    DocumentKindDropDownSelector,
    DateDurationPicker,
    OptionDropDownSelector,
  },
})
export default class FormatPropertyGeneralEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  $configuration!: IConfiguration;

  private documentKindOptions: StandardOption<DocumentKind>[] = [];

  get configuration() {
    return this.$configuration.formatEditor.behavior.format.editor.attributes;
  }

  get companyText(): string {
    return this.$configuration.wording.format.attributes.company + "ID";
  }

  get formatNameText(): string {
    return this.$wording.format.attributes.name + "名";
  }

  get masterCodeText(): string {
    return this.$configuration.wording.format.attributes.masterCode;
  }

  get documentKind(): DocumentKind {
    const option = Enumerable.from(this.documentKindOptions)
      .firstOrDefault(o => (o.value ? parseInt(o.value.id, 10) : null) === this.documentKindId, null);
    return option ? option.value : null;
  }

  set documentKind(value: DocumentKind) {
    this.documentKindId = value ? parseInt(value.id, 10) : null;
  }

  loadedDocumentKind(options: StandardOption<DocumentKind>[]): void {
    this.documentKindOptions = options;
  }

  indicationMagnificationOptions: StandardOption<number>[] = Enumerable.from([ 50, 75, 80, 85, 90, 95, 100, 125, 150, 175, 200 ])
    .select(s => new StandardOption<number>(s + "%", s))
    .toArray();

  categoryTypeOptions: StandardOption<string>[] = [
    new StandardOption<string>("電子文書", "0"),
    new StandardOption<string>("紙文書", "1"),
  ];

  inOutTypeOptions: StandardOption<string>[] = [
    new StandardOption<string>("未設定", "0"),
    new StandardOption<string>("入院", "1"),
    new StandardOption<string>("外来", "2"),
  ];
}
